<template>
  <g
    v-if="node instanceof Group"
    v-show="!node.hidden || isMod"
    :id="htmlId(node._id)"
    ref="nodeRef"
    :style="{
      outline: node.hidden ? '2px dotted red' : undefined,
      cursor: isOneClickLink && node.url ? 'pointer' : 'default',
    }"
    :transform="matrix"
    @contextmenu.prevent
    @click="node.url ? openLink($event, node) : null"
  >
    <Node v-for="child in node.nodes" :id="child._id" :key="child._id" :frame="frame" />
    <title v-if="node.url">{{ linkText }}</title>
  </g>
  <component
    :is="getComponent(node)"
    v-else
    v-show="!node.hidden || isMod"
    :id="node._id"
    ref="nodeRef"
    :style="{
      outline: node.hidden ? '2px dotted red' : undefined,
      cursor: isOneClickLink && node.url ? 'pointer' : 'default',
    }"
    :transform="matrix"
    @contextmenu.prevent
    @click="node.url ? openLink($event, node) : null"
    :title="node.url ? linkText : undefined"
  >
    <title v-if="node.url">{{ linkText }}</title>
  </component>
  <Teleport v-if="hasSelection" :to="frame">
    <component :is="(SelectionComponents as any)[node.selectionComponent]" :id="id" />
  </Teleport>
</template>

<script lang="ts" setup>
import { Group, Node as NodeModel, Slide } from '../models';
import { htmlId } from '../utils/utils';
import Image from './Image.vue';
import Pointer from './Pointer.vue';
import Shape from './Shape.vue';
import Text from './Text.vue';
// import { useDragging } from '../compositions/useDragging'
import { computed, type Ref, ref } from 'vue';
import { history } from '../History';
import * as SelectionComponents from './selections';

const props = defineProps<{
  id: string;
  frame?: HTMLDivElement;
}>();

// FIXME: Nodes stay selected even when they are remotely grouped
// Move "selected" out of node and to Slide or Board
const node = computed(() => NodeModel.get(props.id) as NodeModel);
const nodeRef: Ref<Node | null> = ref(null);

// const frame = computed(() => props.frame)
const matrix = computed(() => node.value.transform.toString());

const getComponent = (node: NodeModel) => {
  if (node.static().model === 'Image') return Image;
  if (node.static().model === 'Pointer') return Pointer;
  if (node.static().model === 'Text') return Text;
  return Shape;
};

const isOneClickLink = computed(() => {
  return node.value.board.readonly || node.value.locked;
});

const linkText = computed(() => {
  return isOneClickLink.value ? 'Click to follow the link.' : 'To follow the link use shift+click.';
});

const openLink = (ev: MouseEvent, node: NodeModel) => {
  // https://github.com/OnlineLearningSessions/whiteboard/issues/78
  node.board.shift = false;

  // Users with whiteboard control need to shift+click to open links.  Otherwise, open links with a regular click
  if (isOneClickLink.value) {
    window.open(node.url as string, '_blank');
  } else if (ev.shiftKey) {
    window.open(node.url as string, '_blank');
  }
};

const isMod = computed(() => history().user.moderator);

const hasSelection = computed(() => {
  return (
    props.frame &&
    node.value.selected &&
    node.value.parent instanceof Slide &&
    (!node.value.locked || node.value.parent.board.locksDisabled) &&
    (!node.value.hidden || isMod)
  );
});
</script>
